module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABXklEQVRYR+2WsU6DUBSG/1MkXZx0MTrrQirc8gA+gbvxAXQwLnVycPMRjJs+gw/gK8gFDQMJAxrHxmCqaYXINaYtqSbFktwrDDDD+T++yzkcQsUXVZyPBiA3YBjGsq639wGsqz6WNKVr3797+s7JAUzLdojAVIeP64vQ5c7mLABZzE4ALP0PAJAmo7bv+0luYJuxvZZo7QJiQzWEEOLW8/j5jyNQHTqvftOGjYH6GOh0uram0QkgVExCHscvp1EUjX53w9QAWaz7DJCK8MnwE5eu6xwVAXCATGXzQBQDwDCMNV1vH87+H2TBZCQe7jm/AfA5z4CsrNJ16tMFpdElPdAYqI+BySTsSVtIiB7fBq8HYRh+FH0uuQGL2X0Aq5K+rfHml4ljz3MuFgEg07L7RFiRC5CdTVevPzci0zS3iLQdALJ2wng4fL8KgmCwiAGZL16qVn26oBS2xJsrN/AF1jtiITHoynsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/menu_left.png
// module id = 971
// module chunks = 41